import { render } from "./DemoStep.vue?vue&type=template&id=d4aacffa&scoped=true"
import script from "./DemoStep.vue?vue&type=script&lang=js"
export * from "./DemoStep.vue?vue&type=script&lang=js"

import "./DemoStep.vue?vue&type=style&index=0&id=d4aacffa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4aacffa"]])

export default __exports__